import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { IViolation } from '../base/annotation';
import { IBaseModel, IDatabaseContent, IEntityFetchedStatus } from './interface';
import { ActionConstants } from '../../constants/action-constants';
import { DatabaseEntity } from './databaseEntity';
import { ValidationConstants } from '../../shared/validation-constants';
import { getGeneralNamePatterns } from '../../shared/utils/validation.util';
import { format } from '../../shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.database,
    display: [shellStringResources.SynapseDatabases],
    reusable: true,
    referable: true,
    validator: Database.validate,
    constraints: {
        name: {
            required: true,
            patterns: [
                ...getGeneralNamePatterns(shellStringResources.SynapseDatabases),
                { regex: ValidationConstants.gitBlockedNamesValidator, message: shellStringResources.Validator_Database_Name_Blocked_Git }
            ],
            uniqueModelName: true
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.datasetsWrite
        },
        deleteResource: {
            action: ActionConstants.datasetsDelete
        }
    }
})
export class Database extends DatabaseEntity {
    @Metamodel.attribute({
        display: shellStringResources.Name
    })
    public name: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Description
    })
    public description?: string;

    @Metamodel.attribute({
    })
    public isSyMSCDMDatabase: boolean = false;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Content
    })
    public content?: IDatabaseContent;

    @Metamodel.attribute({
    })
    public baseModel?: IBaseModel; // only database based on idw models has this attribute

    @Metamodel.attribute({
    })
    public isEntitiesFetched: IEntityFetchedStatus = {
        table: false,
        relationship: false
    };

    /**
     * The value is used to generate publish payload
     * It would only be set in tabOptions.preSave, which is called just before publish
     */
    @Metamodel.attribute({
    })
    public entities?: DatabaseEntity[] = [];

    constructor(name?: string, description?: string, databaseContent?: IDatabaseContent, baseModel?: IBaseModel) {
        super(name, description, null);
        this.content = databaseContent;
        this.baseModel = baseModel;
        this.resourceType = ModelConstants.database + 's';

        if (baseModel != null) {
            this.isSyMSCDMDatabase = true;
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validate(owner: any): IViolation[] | undefined {
        // Prevent users from publishing database before the functionality is ready.
        if (owner?.named?.extension?.dummy) {
            return [{
                context: owner,
                message: () => shellStringResources.DatabasePublishUnsupported
            }];
        }

        // Prevent all new databases being created from having a space. We are checking mdEntity.objectId, which will be absent for new databases
        if (owner?.named && !owner.named?.mDEntity?.objectId && !ValidationConstants.alphanumericUnderscoreValidator.test(owner.named.name)) {
            return [{
                context: owner,
                message: () => format(shellStringResources.Validator_NamePattern_All_AlphanumericUnderscore, shellStringResources.SynapseDatabases)
            }];
        }

        return undefined;
    }
}
